import * as React from 'react';
import {Overlay} from '@packages/systems/ui/overlay';
import {Z_INDEXES} from '@packages/utilities/styled';
import {useWindowSize} from '@packages/systems/spring-hooks';
import {FloatingTree} from '@floating-ui/react';

/**
 * A wrapper to set up an Overlay portal provider that updates dynamically.
 */
// @ts-expect-error - TS7031 - Binding element 'children' implicitly has an 'any' type.
const SpringOverlayWrapper = ({children}) => {
  const {height, width} = useWindowSize();

  return (
    <Overlay
      height={height}
      left={0}
      style={{zIndex: Z_INDEXES.zIndexNotifications}}
      top={0}
      width={width}
    >
      {children}
    </Overlay>
  );
};

export const SpringOverlayContext = React.createContext<boolean>(false);

export const useSpringOverlay = () => React.useContext(SpringOverlayContext);

type SpringOverlayProps = {
  shouldNotMountOverlay?: boolean;
  children: React.ReactNode;
};

/**
 * We only want to inject a root Overlay once, so we use a context to track it.
 */
export const SpringOverlay = ({
  shouldNotMountOverlay = false,
  children,
}: SpringOverlayProps) => {
  const isNested = useSpringOverlay();
  const TreeProvider = isNested ? React.Fragment : FloatingTree;

  const content =
    isNested || shouldNotMountOverlay ? (
      children
    ) : (
      <SpringOverlayWrapper>{children}</SpringOverlayWrapper>
    );

  /**
   * We are disabling eslint for the Provider just to be extra explicit about what we are doing here.
   */

  return (
    // eslint-disable-next-line react/jsx-boolean-value
    <SpringOverlayContext.Provider value={true}>
      <TreeProvider>{content}</TreeProvider>
    </SpringOverlayContext.Provider>
  );
};
